module.exports = __webpack_public_path__ + "static/media/password-boss-integration-with-control.b9677938.png";